import React, { Component, createRef } from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckDouble,
  faPaperclip,
  faPaperPlane,
  faTrash,
  faTimes,
  faPrint,
  faDownload
} from "@fortawesome/free-solid-svg-icons";
import "./Conversation.scss";
import config from "config";
import vendorApiCall from "vendorApiCall";
import { ToastContainer, toast } from "react-toastify";
import { Base64 } from 'js-base64';
import axios from "axios";
import AttachmentManagerModal from "./AttachmentManagerModal";
import ReactToPrint from "react-to-print";


let apiPath = "/vendor/api/vendor.php";


class PurchaseRequestConversation extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = createRef();
    const { vendorId, prId, prVendorId, iid, selectedClientName} = this.props;
    this.state = {
      vendorName: "vendor",
      facultyName: "faculty",
      vendorId,
      prId,
      prVendorId,
      facultyId: config.faculty_id,
      iid,
      messages: [],
      newMessage: "",
      selectedFiles: [],
      sending: false,
      footerMessage: "",
      showAttachment:false,
      fileName:'',
      fileId:null,
      showAttachmentModal: false,
      tempSelectedFiles: [],
    };

    this.lastMessageRef = createRef();
    this.fileInputRef = createRef();
  }

  componentDidMount() {
    this.fetchMessages();

    this.intervalId = setInterval(() => {
      this.fetchMessagesInterval();
      this.setState({ footerMessage: `Last refreshed at ${moment().format("hh:mm:ss A")}` });
    }, 10000);
  }

  componentWillUnmount() {

    clearInterval(this.intervalId);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.prId !== this.props.prId ||
      prevProps.prVendorId !== this.props.prVendorId
    ) {
      this.fetchMessages();
    }
   
  }

  scrollToBottom = () => {
    if (this.lastMessageRef.current) {
      this.lastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  fetchMessages = async () => {
    const { prVendorId } = this.props;
    this.setState({ sending: true });
    const requestData = {
      prVendorId: this.props.prVendorId,
      userRole: "vendor",
    };

    try {
      const jsonResponse = await vendorApiCall.makeApiCall(
        "inventory_getPurchaseRequestCommunication",
        requestData,
        apiPath
      );

      const response = jsonResponse?.APIResult || {};

      if (response.success) {
        const rawMessages = response.data || {};
        const messagesArray = Object.values(rawMessages).sort(
          (a, b) => new Date(a.addedOn) - new Date(b.addedOn)
        );

        this.setState({ messages: messagesArray, sending: false });
        this.scrollToBottom();
      } else {
        console.error(
          "Failed to fetch messages:",
          response.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error while fetching messages:", error);
    }
  };
  fetchMessagesInterval = async () => {
    const { prVendorId } = this.props;
   
    const requestData = {
      prVendorId: this.props.prVendorId,
      userRole: "vendor",
    };

    try {
      const jsonResponse = await vendorApiCall.makeApiCall(
        "inventory_getPurchaseRequestCommunication",
        requestData,
        apiPath
      );

      const response = jsonResponse?.APIResult || {};

      if (response.success) {
        const rawMessages = response.data || {};
        const messagesArray = Object.values(rawMessages).sort(
          (a, b) => new Date(a.addedOn) - new Date(b.addedOn)
        );

        this.setState({ messages: messagesArray});
      } else {
        console.error(
          "Failed to fetch messages:",
          response.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error while fetching messages:", error);
    }
  };

  formatTime = (timestamp) => moment(timestamp).format("hh:mm A");

  formatDate = (timestamp) => moment(timestamp).format("MMMM DD, YYYY");

  handleInputChange = (event) => {
    this.setState({ newMessage: event.target.value });
  };

  handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    this.setState({ selectedFiles: files });
  };

  handleSendMessage = async () => {
    try {
      const {
        newMessage,
        prVendorId,
        vendorId,
        prId,
        facultyId,
        iid,
        selectedFiles,
      } = this.state;

      if (!newMessage.trim() && selectedFiles.length === 0) {
        toast.error('Message can not be empty.', {
                position: toast.POSITION.BOTTOM_RIGHT,
              })
        return;
      }

      this.setState({ sending: true });

      const attachments = selectedFiles.map((file) => ({
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
      }));

      const formData = new FormData();
      formData.append("inventory_addPurchaseRequestCommunication", true);
      formData.append(
        "data",
        Base64.encode(
          JSON.stringify({
            prVendorId,
            vendorId,
            iid,
            userId: vendorId,
            prId,
            userRole: "vendor",
            message: newMessage.trim(),
          })
        )
      );

      if (selectedFiles.length > 0) {
        selectedFiles.forEach((attachment) => {
          formData.append("files[]", attachment);
        });
      } else {
        formData.append("files[]", "");
      }

      const parameterData = JSON.stringify({
        source: "app",
        uid: config.instructorInfo.data.vendorId,
        email: config.instructorInfo.data.EmailId,
        role: "vendor",
      });

      formData.append("tokenInputParameter", Base64.encode(parameterData));

      const headers = {
        Accept: "application/json",
        Authorization: "Basic " + config.user_token,
      };

      const response = await axios.post(config.RootUrl + apiPath, formData, {
        headers: headers,
      });

      const jsonResponse = response.data;

     
      if (response.data.success) {
        // this.setState((prevState) => ({
        //   messages: [
        //     ...prevState.messages,
        //     {
        //       uniqueId: prevState.messages.length + 1,
        //       userRole: "vendor",
        //       message: newMessage.trim(),
        //       addedOn: moment().format("YYYY-MM-DD HH:mm:ss"),
        //       readStatus: "sent",
        //       attachments,
        //     },
        //   ],
        //   newMessage: "",
        //   selectedFiles: [],
        // }));
        this.setState({ newMessage: "", selectedFiles: [] });
        this.fetchMessages();
      } else {
        toast.error('Message can not be empty.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        console.error(
          "Failed to send message:",
          response.data.message
        );
      
      }
    } catch (error) {
      console.error("Error while sending message:", error);
    } finally {
      this.setState({ sending: false });
    }
  };

  renderMessages() {
    const { messages } = this.state;

    if (messages.length === 0) {
      return (
        <div
          className="message"
          style={{ paddingRight: "10px", height: "54vh" }}
        >
          <p style={{ padding: "15px" }}>
            No messages available. Start the conversation by sending a message!
          </p>
        </div>
      );
    }

    return messages.map((msg, index) => {
      const isVendor = msg.userRole === "vendor";
      const name = isVendor ? this.state.vendorName : this.state.facultyName;

      const isLastMessage = index === messages.length - 1;

      // Split the attachmentArray into individual file names
      const attachments =
      msg.attachmentArray?.trim()
        ? msg.attachmentArray.split(",").map((fileName, idx) => ({
            id: idx,
            name: `Attachment ${idx + 1}`,
            fileName,
          }))
        : [];

      return (
        <div
          key={msg.uniqueId}
          className={`message-container ${isVendor ? "right" : "left"}`}
          ref={isLastMessage ? this.lastMessageRef : null}
        >
          <div className="icon-circle" title={isVendor ? name:this.props.selectedClientName }>
            {isVendor ? name.charAt(0).toUpperCase() :  this.props.selectedClientName.charAt(0).toUpperCase()}
          </div>
          <div className="message-wrapper">
            <div className="message-bubble">
              <p>{msg.message}</p>
              {attachments.length > 0 && (
                <ul className="attachments-list" style={{color:'skyblue'}}>
                  {attachments.map((attachment) => (
                    <li key={attachment.id}>
                      <a
                        
                        onClick={() =>
                          this.handleOpenAttachment(msg.path,attachment.fileName, msg.uniqueId)
                        }
                      >
                        {attachment.name}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="message-timestamp">
              {this.formatDate(msg.addedOn)} at {this.formatTime(msg.addedOn)}
              <FontAwesomeIcon
                icon={faCheckDouble}
                className="read-status-icon"
                style={{
                  color: msg.readStatus === "seen" ? "skyblue" : "gray",
                  marginLeft: "8px",
                }}
              />
            </div>
          </div>
        </div>
      );
    });
  }


  handleOpenAttachment = (path,fileName, id) => {

    this.setState({
      showAttachment: true,
      fileName:`${path}/${fileName}`,
      fileId:id
    });
  };
// Inside your class component:
renderOpenAttachment() {
  const { showAttachment, fileName } = this.state;
  if (!showAttachment) return null;

  const fileUrl = `${fileName}`;
  const isImage = /\.(jpeg|jpg|png|gif|webp)$/i.test(fileUrl);
  const isPDF = /\.pdf$/i.test(fileUrl);

  return (
    <div className="modal-view-attachment">
      <div className="modal-content-view-attachment">
        <div className="modal-header-view-attachment">
          <p style={{ fontSize: "18px", margin: 0 }}>Attachment</p>

          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            {(isImage) && (
              <>
            
              <ReactToPrint
                trigger={() => (
                  <button
                    className="print-button-view-attachment"
                    title="Click here to print attachement"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      padding: "4px 8px",
                      background: "#f5f5f5",
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon icon={faPrint} />
                  
                  </button>
                )}
                content={() => this.printRef}
              />

               <ReactToPrint
                trigger={() => (
                  <button
                    className="print-button-view-attachment"
                    title="Click here to download attachment"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      padding: "4px 8px",
                      background: "#f5f5f5",
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload} />
                 
                  </button>
                )}
                content={() => this.printRef}
              />
                </>
            )}
            <button
              className="close-button-view-attachment"
              onClick={() => this.setState({ showAttachment: false })}
              title="Close"
              style={{
                border: "1px solid #ccc",
                borderRadius: "6px",
                padding: "4px 4px",
                background: "#f5f5f5",
                cursor: "pointer",
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </div>

        <div ref={(el) => (this.printRef = el)} style={{ textAlign: "center" }}>
          {isImage ? (
            <img
              src={fileUrl}
              alt="Preview"
              style={{
                width: "100%",
                maxWidth: "100%",
                height: "400px",
                objectFit: "contain",
              }}
            />
          ) : isPDF ? (
            <iframe
              src={fileUrl}
              title="PDF Preview"
              style={{
                width: "100%",
                height: "80vh",
                border: "none",
              }}
            ></iframe>
          ) : (
            <p>Unsupported file type.</p>
          )}
        </div>
      </div>
    </div>
  );
}
  handleFileSelect = (event) => {
    const files = Array.from(event.target.files);

    // Validate file types (allow only JPG and PDF)
    const validFiles = files.filter(
      (file) =>
        file.type === "application/pdf" ||
        file.type === "image/jpeg" ||
        file.type === "image/png"
    );

    const invalidFiles = files.filter(
      (file) => file.type !== "application/pdf" && file.type !== "image/jpeg"
    );

    if (invalidFiles.length > 0) {
      toast.error(
        "Some files were not added because only JPG and PDF files are allowed.",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
        }
      );
    }

    this.setState((prevState) => ({
      selectedFiles: [...prevState.selectedFiles, ...validFiles],
    }));
  };

  removeFile = (index) => {
    this.setState((prevState) => {
      const updatedFiles = [...prevState.selectedFiles];
      updatedFiles.splice(index, 1);
      return { selectedFiles: updatedFiles };
    });
  };

  renderFilePreview = () => {
    const { selectedFiles } = this.state;

    if (selectedFiles.length === 0) {
      return null;
    }

    return (
      <div >
        {/* <ul>
          {selectedFiles.map((file, index) => (
            <li key={index} className="file-item">
              <span>{file.name}</span>
              <button
                className="remove-file-button"
                onClick={() => this.removeFile(index)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </li>
          ))}
        </ul> */}
      </div>
    );
  };

  render() {
    return (
      <div className="conversation-body">
        <div className="message" style={{width:'52vw', height: '68vh'}}>
          {this.renderMessages()}
          {this.renderFilePreview()}
          {this.renderOpenAttachment()}
        </div>

        <div className="input-container">
          <input
            type="text"
            placeholder="Type your message here..."
            value={this.state.newMessage}
            onChange={this.handleInputChange}
            onKeyDown={(event) => {
              if (event.key === "Enter" && !this.state.sending) {
                this.handleSendMessage();
              }
            }}
            disabled={this.state.sending}
            style={{botder:'0px solid white', outline:'none'}}
          />
         <button
            className="attachment-button"
            onClick={() => this.setState({ showAttachmentModal: true })}
            disabled={this.state.sending}
          >
            <FontAwesomeIcon icon={faPaperclip} />
          </button>
          <input
            type="file"
            multiple
            ref={this.fileInputRef}
            style={{ display: "none" }}
            onChange={(e) => {
              const files = Array.from(e.target.files);
              const valid = files.filter(
                (file) =>
                  file.type === "application/pdf" ||
                  file.type === "image/jpeg" ||
                  file.type === "image/png"
              );
              const invalid = files.length - valid.length;
              if (invalid > 0) {
                toast.error("Only PDF, JPG, PNG are allowed.");
              }
              this.setState((prev) => ({
                tempSelectedFiles: [...prev.tempSelectedFiles, ...valid]
              }));
            }}
          />
          <button
            className={`send-button ${this.state.sending ? "disabled" : ""}`}
            onClick={this.handleSendMessage}
            disabled={this.state.sending}
          >
            {this.state.sending ? (
              <FontAwesomeIcon icon="spinner" spin />
            ) : (
              <FontAwesomeIcon icon={faPaperPlane} />
            )}
          </button>
        </div>
          <ToastContainer theme="light" />
          {this.state.showAttachmentModal && (
  <AttachmentManagerModal
    files={this.state.tempSelectedFiles}
    onRemove={(index) => {
      const updated = [...this.state.tempSelectedFiles];
      updated.splice(index, 1);
      this.setState({ tempSelectedFiles: updated });
    }}
    onAddFiles={(newFiles) => {
      this.setState((prev) => ({
        tempSelectedFiles: [...prev.tempSelectedFiles, ...newFiles],
      }));
    }}
    onClose={() => this.setState({ showAttachmentModal: false })}
    onSendMessage={(msgText) => {
      this.setState(
        (prev) => ({
          newMessage: msgText,
          selectedFiles: [...prev.selectedFiles, ...prev.tempSelectedFiles],
          tempSelectedFiles: [],
          showAttachmentModal: false,
        }),
        this.handleSendMessage // callback to send after state set
      );
    }}
  />
)}


      </div>
      
    );
  }
}

export default PurchaseRequestConversation;